(function () {
    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.refreshedourstoryhistorysliderblock = window.oneadvanced.refreshedourstoryhistorysliderblock || {};
    window.oneadvanced.refreshedourstoryhistorysliderblock.init = function () {

        //This function is used to add the swipper for refreshedourstoryhistorysliderblock
        function cfcHandler(BlockId) {
            const prevButton = document.getElementById('swiperPrev_' + BlockId);
            const nextButton = document.getElementById('swiperNext_' + BlockId);

            prevButton.classList.add('inactive');
            const swiper = new Swiper('[data-stories-block-id="' + BlockId + '"]', {
                direction: 'horizontal',
                slidesPerView: 'auto',
                initialSlide: 0,
                loop: false,
                grabCursor: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                on: {
                    slideChange: function () {
                        updateCircleIndicators(swiper.activeIndex);
                        toggleButtons(prevButton, nextButton, swiper);
                    },
                },
            });

             // Add inactive class for next button
            function toggleButtons(prevButton, nextButton, swiper) {
                if (swiper.isBeginning) {
                    prevButton.classList.add('inactive');
                } else {
                    prevButton.classList.remove('inactive');
                }

                if (swiper.isEnd) {
                    nextButton.classList.add('inactive');
                } else {
                    nextButton.classList.remove('inactive');
                }
            }

            updateCircleIndicators(0);

            function updateCircleIndicators(activeIndex) {
                var circles = document.querySelectorAll('.circle-indicators');
                var sliderText = document.querySelectorAll('.slider-title');
                circles.forEach(function (circle, index) {
                    if (index === activeIndex || (activeIndex === 0 && index === circles.length - 1)) {
                        circle.classList.add('active');
                    } else {
                        circle.classList.remove('active');
                    }
                });
                sliderText.forEach(function (text, index) {
                    if (index === activeIndex || (activeIndex === 0 && index === circles.length - 1)) {
                        text.classList.add('active');
                    } else {
                        text.classList.remove('active');
                    }
                });
            }
        }

         //Below Code is used to add swiper-slide class to the carousel for the larger screens other than mobile
        var swiper_wraper_content = document.querySelectorAll('.refreshedourstoryhistorysliderblock .swiper-wrapper');

        for (var i = 0; i < swiper_wraper_content.length; i++) {
            for (var e = 0; e < swiper_wraper_content[i].children.length; e++) {
                swiper_wraper_content[i].children[e].classList.add("swiper-slide");
            }
        }

        //Below Code is used to add swiper-slide class to the carousel for the larger screens other
        var swiper_container_content = document.querySelectorAll('.refreshedourstoryhistorysliderblock .swipe-container');

        for (var i = 0; i < swiper_container_content.length; i++) {
            for (var e = 0; e < swiper_container_content[i].children.length; e++) {
                swiper_container_content[i].children[e].classList.add("swipe-slide");
            }
        }
         var ourstoryhistorysliderblock = document.querySelectorAll('[data-stories-block-id]');

          //Below code is to call the cfcHandler function defined above
        if (ourstoryhistorysliderblock.length) {
            for (var cfc = 0; cfc < ourstoryhistorysliderblock.length; cfc++) {
                cfcHandler(
                    ourstoryhistorysliderblock[cfc].getAttribute('data-stories-block-id')
                );
            }
        }
    };

    window.oneadvanced.refreshedourstoryhistorysliderblock.hasLoaded = true;
})();